
// 期间选择器
import SmartPeriodSelect from "@/components/commons/SmartPeriodSelect.vue";
// 上下半年选择器
import SmartYearSelect from "@/components/commons/SmartYearSelect.vue";
// 底部栏：首页，我的
import Tabs from "@/components/commons/Tabs.vue";
// 搜索框
import SearchBox from "@/components/commons/SearchBox.vue";

export default {
    install(Vue) {
		// 期间选择器
		Vue.component('JXCSmartPeriodSelect', SmartPeriodSelect);
		// 上下半年选择器
		Vue.component('JXCSmartYearSelect', SmartYearSelect);
        // 底部栏：首页，我的
        Vue.component('JXCTabs', Tabs);
		// 搜索框
		Vue.component('JXCSearchBox', SearchBox);
    }
}